import { setMeta, checkRule } from '@/router/middleware'
import routerView from '@/views/transactions/routerView'


const List = () => import('@/views/transactions/List')
const ChargeAccount = () => import('@/views/transactions/ChargeAccount')
const Wallet = () => import('@/views/transactions/Wallet')
const Transactions = () => import('@/views/transactions/Transactions')
const ChargeAccountResponse = () => import('@/views/transactions/ChargeAccountResponse')
const Reports = () => import('@/views/transactions/Reports')
const PublishersCheckoutList = () => import ('@/views/transactions/PublishersCheckoutList')
const NegativeStoresList = () => import ('@/views/transactions/NegativeStoresList')
// const CheckoutRequest = () => import ('@/views/transactions/CheckoutRequest')
// const CheckoutRequestsReports = () => import ('@/views/transactions/CheckoutRequestsReports')
// const CheckoutRequestHint = () => import ('@/views/transactions/CheckoutRequestHint')
const Invoices = () => import ('@/views/transactions/Invoices')
const InvoiceDetails = () => import('@/views/transactions/InvoiceDetails')

export default {
    path: 'transactions',
    redirect: '',
    component: routerView,
    children: [
        {
            path: '',
            name: 'transactions',
            component: List,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.plural',
                rules: {
                    transaction: ['read_any', 'read_group', 'read_own']
                },
            }
        },
        {
            path: 'reports',
            name: 'transactions.reports',
            component: Reports,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'report.plural',
                rules: {
                    'store.join': ['execute_any']
                },
            }
        },
        {
            path: 'charge',
            name: 'transactions.charge',
            component: ChargeAccount,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.charge',
                rules: {
                    financial: ['write_any', 'write_group', 'write_own']
                },
            }
        },
        {
            path: 'charge/response',
            name: 'transactions.charge_response',
            component: ChargeAccountResponse,
            meta: {
                // if set middleware may be redirect to /
                labelTrans: 'transactions.charge_response',
            }
        },
        {
            path: 'wallet',
            name: 'transactions.wallet',
            component: Wallet,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.wallet',
                rules: {
                    wallet: ['read_any', 'read_group', 'read_own']
                },
            },
        },
        {
            path: 'wallet/:id',
            name: 'wallet.transactions',
            component: Transactions,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.transactions',
                rules: {
                    wallet: ['read_any', 'read_group', 'read_own']
                },
            },
        },
        {
            path: 'publishers-checkout-list',
            name: 'transactions.checkout_list',
            component: PublishersCheckoutList,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.checkout_list',
                rules: {
                    financial: ['write_any']
                },
            },
        },
        {
            path: 'negative-stores-list',
            name: 'transactions.negative_stores_list',
            component: NegativeStoresList,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'transaction.negative_stores_list',
                rules: {
                    financial: ['write_any']
                },
            },
        },
        {
            path: 'invoices',
            name: 'invoices',
            component: Invoices,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'invoice.plural',
                rules: {
                    financial: ['write_any', 'write_group', 'write_own']
                },
            },
        },
        {
            path: 'invoices/:id',
            name: 'invoices.details',
            component: InvoiceDetails,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'invoice.details',
                rules: {
                    financial: ['write_any', 'write_group', 'write_own']
                },
            },
        },
        // {
        //     path: 'checkout-request',
        //     name: 'transactions.checkout_request',
        //     component: CheckoutRequest,
        //     meta: {
        //         middleware: [setMeta, checkRule],
        //         labelTrans: 'transactions.checkout_request',
        //         rules: {
        //             transactions: ['checkout_request']
        //         },
        //         hint: CheckoutRequestHint,
        //     }
        // },
        // {
        //     path: 'checkout-requests-reports',
        //     name: 'transactions.checkout_requests_reports',
        //     component: CheckoutRequestsReports,
        //     meta: {
        //         middleware: [setMeta, checkRule],
        //         labelTrans: 'transactions.checkout_requests_reports',
        //         rules: {
        //             transactions: ['checkout_requests_reports']
        //         },
        //     }
        // },
    ]
}